/* COPYRIGHT Esri - https://js.arcgis.com/5.1/LICENSE.txt */
const r = {
  dragHorizontal: "esri-icon-drag-horizontal",
  dragVertical: "esri-icon-drag-vertical"
};
export {
  r as l
};
